import OrderBookPresenter from "@adapters/features/OrderBook/Presenters/OrderBook";
export default (function (useCases, actions) {
    return new OrderBookPresenter(useCases.orderBook, actions);
});
